import React, { Component } from 'react';
import './ManualBooking.css';
import { Select, DateRangePicker, Input, Checkbox, Button } from 'element-react';
import { blockedDaysByRoom, manualBooking } from '../../services/bookings';
import { getRoomById, getRoomPriceByHostagesAndDates } from '../../services/rooms';
import { useParams } from 'react-router-dom';

class ManualBooking extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      options: [
        {
          value: '5ba2a6e4781811c4b2c4c609',
          label: 'Quintanic',
          pax: 4,
          pack: [2]
        },
        {
          value: '5ba2a6b00dc419c4b22fa27c',
          label: 'Coll s`Espunya',
          pax: 3,
          pack: [1]
        },
        {
          value: '5ba2a714781811c4b2c4c60a',
          label: 'Pla del Grèvol',
          pax: 3,
          pack: [1]
        },
        {
          value: '5ebfbcce3188813b7c0e0f34',
          label: 'Puigsaleres',
          pax: 3,
          pack: [1]
        },
        {
          value: '5e1cc2b102ff5f32acc48460',
          label: 'Del Noguer',
          pax: 4,
          pack: [3]
        },
        {
          value: '5e1cc2be02ff5f32acc48461',
          label: 'La Barraca',
          pax: 4,
          pack: [3]
        }
      ],
      room: undefined,
      checkInDate: undefined,
      checkOutDate: undefined,
      loading: false,
      bookings: [],
      numAdults: undefined,
      numChilds: undefined,
      baseAmount: 0,
      total: undefined,
      optionsAdults: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: 3
      }, {
        value: 4,
        label: 4
      }],
      optionsChilds: [{
        value: 0,
        label: '0'
      }, {
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: 2
      }, {
        value: 3,
        label: 3
      }],
      childsAges: [],
      childsAge: [
        { value: 0, label: '0 años' },
        { value: 1, label: '1 año' },
        { value: 2, label: '2 años' },
        { value: 3, label: '3 años' },
        { value: 4, label: '4 años' },
        { value: 5, label: '5 años' },
        { value: 6, label: '6 años' },
        { value: 7, label: '7 años' },
        { value: 8, label: '8 años' },
        { value: 9, label: '9 años' },
        { value: 10, label: '10 años' },
        { value: 11, label: '11 años' },
        { value: 12, label: '12 años' },
        { value: 13, label: '13 años' },
        { value: 14, label: '14 años' },
        { value: 15, label: '15 años' },
        { value: 16, label: '16 años' },
        { value: 17, label: '17 años' },
      ],
      contactNameLastname: undefined,
      contactPhoneNumber: undefined,
      contactEmail: undefined,
      contactComments: undefined,
      sendConfirmation: true,
      updatingTotal: false,
      addHalfPension: false,
      totalHalf: 0,
      buying: false
    };
  }

  pickRoom(val) {
    this.setState({ room: val, loading: true, checkInDate: null });
    this.getBlockedDays(val);
    this.getRoomPrice(val);
  }

  async getBlockedDays(roomId) {
    try {
      const { data: { bookings } } = await blockedDaysByRoom(roomId);
      this.setState({ bookings, loading: false });
    } catch (err) {
      console.error(err);
    }
  }

  async getRoomPrice(roomId, checkIn, checkOut) {
    try {
      this.setState({ updatingTotal: true });

      const info = {
        numAdults: this.state.numAdults,
        numChilds: this.state.numChilds,
        childsAges: this.state.childsAges,
        checkIn: checkIn,
        checkOut: checkOut,
      };
      const { data: { total } } = await getRoomPriceByHostagesAndDates(roomId, info);
      this.setState({ total: total, baseAmount: total, updatingTotal: false });
    } catch (err) {
      console.error(err);
    }
  }

  checkBlockedDay(date) {
    if (date < new Date()) return true;
    for (let i = 0; i < this.state.bookings.length; i++) {
      const dateBlocked = new Date(this.state.bookings[i]);
      if (date.getFullYear() === dateBlocked.getFullYear()
        && date.getMonth() === dateBlocked.getMonth()
        && date.getDate() === dateBlocked.getDate()) return false;
    }

    return true;
  }

  setDates(date) {
    if (date) {
      this.setState({ checkInDate: date });
      this.getRoomPrice(this.state.room, date[0], date[1]);
    }
  }

  setNumChilds(val) {
    let childs = [];
    for (let i = 0; i < val; i++) childs.push(undefined);
    this.setState({ numChilds: val, childsAges: childs });
  }

  changeSendConfirmation(value) {
    this.setState({ sendConfirmation: value });
  }

  deltaDays = (date1, date2) => {
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  }

  changeHalfPension(value) {
    // calc new price
    const total = this.state.total;
    // filter childs < 3 years
    const childsAges = this.state.childsAges.filter((age) => age >= 3);
    const totalHalf = ((25 * this.state.numAdults) + ((25 / 2) * childsAges.length)) * (this.deltaDays(this.state.checkInDate[0], this.state.checkInDate[1]));

    this.setState({
      addHalfPension: value,
      totalHalf: value ? totalHalf : 0,
      total: value ? (total + totalHalf) : this.state.total - this.state.totalHalf
    });
  }

  setChildAge(val, index) {
    console.log(val, index);
    const childs = this.state.childsAges;
    childs[index] = val;
    this.setState({ childsAges: childs });
  }

  async create() {
    this.setState({ buying: true });
    try {
      const query = new URLSearchParams(this.props.location.search);
      const presentId = query.get('presentId');

      const data = {
        checkInDate: new Date(Date.UTC(this.state.checkInDate[0].getFullYear(), this.state.checkInDate[0].getMonth(), this.state.checkInDate[0].getDate())),
        checkOutDate: new Date(Date.UTC(this.state.checkInDate[1].getFullYear(), this.state.checkInDate[1].getMonth(), this.state.checkInDate[1].getDate())),
        state: 2,
        roomId: this.state.room,
        baseAmount: this.state.baseAmount,
        totalPaid: this.state.total,
        details: {
          info: {
            name: this.state.contactNameLastname,
            phone: this.state.contactPhoneNumber,
            email: this.state.contactEmail,
            commentary: this.state.contactComments,
          },
          activities: null,
          pack: null,
          restaurant: this.state.addHalfPension ? 'half' : null,
          numBikes: 0,
          cancer: null,
          totalDonation: 0,
          numAdults: this.state.numAdults,
          numChilds: this.state.numChilds,
          childsAges: this.state.childsAges
        },
        lang: null,
        sendConfirmation: this.state.sendConfirmation,
        presentId: presentId || null
      };

      await manualBooking(data.roomId, data);
      this.setState({ buying: false });
      this.props.history.goBack();
    } catch (err) {
      this.setState({ buying: false });
      alert("IMPORTANT: Error. Primer de tot comprova que no s'hagi creat la reserva, no tornis a provar de crearla. Després contacta amb el proveedor web.");
    }
  }

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const presentId = query.get('presentId');
    const pack = parseInt(query.get('pack'), 10);

    return (
      <div className="manualBookingWrapper">
        <div className="totalStep">
          <h4>Precio: {
            this.state.updatingTotal
              ? <i className="el-icon-loading"></i>
              : !this.state.total
                ? '??? €'
                : `${this.state.total} €`
          }
          </h4>
        </div>

        {presentId && <div><h4>Canjeando regala: #{presentId} con pack #{pack}</h4><p>No se genera num factura y se asocia la reserva al regala</p></div>}

        <div className="step">
          <h4>1. Número adults</h4>
          <Select value={this.state.numAdults} onChange={(val) => this.setState({ numAdults: val })}>
            {
              this.state.optionsAdults.map(el => {
                return <Select.Option key={`adult-${el.value}`} label={el.label} value={el.value} />
              })
            }
          </Select>
        </div>
        {
          this.state.numAdults
          && <div className="step">
            <h4>2. Número infants</h4>
            <Select value={this.state.numChilds} onChange={(val) => this.setNumChilds(val)}>
              {
                this.state.optionsChilds.map(el => {
                  return <Select.Option key={`child-${el.value}`} label={el.label} value={el.value} />
                })
              }
            </Select>
            {
              this.state.childsAges.map((numChildsAges, index) => {
                return <Select value={numChildsAges} onChange={(val) => this.setChildAge(val, index)}>
                  {
                    this.state.childsAge.map(el => {
                      return <Select.Option key={`child-age-${el.value}`} label={el.label} value={el.value} />
                    })
                  }
                </Select>
              })
            }
          </div>
        }
        {
          this.state.numAdults && (this.state.numChilds === 0 || (this.state.numChilds > 0 && !this.state.childsAges.includes(undefined)))
          && <div className="step">
            <h4>3. Escollir cabanya</h4>
            <Select value={this.state.value} onChange={(val) => this.pickRoom(val)}>
              {
                this.state.options.filter((room) => presentId && pack ? (room.pack || []).includes(pack) : true).map(el =>
                  el.pax >= (this.state.numAdults + this.state.numChilds)
                  && <Select.Option key={el.value} label={el.label} value={el.value} />
                )
              }
            </Select>
          </div>
        }
        {
          this.state.room
          && <div className="step">
            <h4>4. Escollir dia bloquejat previament</h4>
            {
              this.state.loading
                ? <i className="el-icon-loading"></i>
                : <DateRangePicker
                  firstDayOfWeek="1"
                  format="dd-MM-yyyy"
                  value={this.state.checkInDate}
                  placeholder="Pick a range"
                  onChange={date => this.setDates(date)}
                  disabledDate={date => this.checkBlockedDay(date)}
                />
            }
          </div>
        }
        {
          this.state.room && this.state.checkInDate
          && <div className="step">
            <h4>5. Dades de la reserva</h4>
            <div className="contactForm">
              <div className="contactField">
                <p>Nombre de la reserva</p>
                <Input placeholder="Escribir ..." value={this.state.contactNameLastname} onChange={val => this.setState({ contactNameLastname: val })} />
              </div>
              <div className="contactField">
                <p>Número de contacto</p>
                <Input placeholder="Escribir ..." value={this.state.contactPhoneNumber} onChange={val => this.setState({ contactPhoneNumber: val })} />
              </div>
              <div className="contactField">
                <p>Email</p>
                <Input placeholder="Escribir ..." value={this.state.contactEmail} onChange={val => this.setState({ contactEmail: val })} />
              </div>
              <div className="contactField">
                <p>Comentari</p>
                <Input type="textarea" placeholder="Escribir ..." value={this.state.contactComments} onChange={val => this.setState({ contactComments: val })} />
              </div>
            </div>
          </div>
        }
        {
          this.state.room && this.state.checkInDate
          && <div className="step">
            <Checkbox
              checked={this.state.sendConfirmation}
              onChange={(val) => this.changeSendConfirmation(val)}>Enviar email de confirmació al client</Checkbox>
            <Checkbox
              checked={this.state.addHalfPension}
              onChange={(val) => this.changeHalfPension(val)}>Afegir sopar</Checkbox>
          </div>
        }
        {
          this.state.room && this.state.checkInDate
          && <div className="step">
            {this.state.buying ? <i className="el-icon-loading"></i> : <Button onClick={() => this.create()}>Crear reserva</Button>}
            {presentId && pack && <p>Esta reserva NO genera una factura</p>}
          </div>
        }
      </div>
    );
  }
}

export default ManualBooking;



// WEBPACK FOOTER //
// ./src/components/ManualBooking/ManualBooking.js